/* The two controls in the Rockkt One mock that did nothing.

   "Verify address with recipient" looked like a checkbox and could not be
   ticked; "Continue in Portal" carried cursor:pointer and had no handler. Both
   now open a panel under themselves — see rockkt-home-fx-v1.css for the motion.

   The panels are built here rather than living in templates/index.liquid,
   which is 236KB and past what the Admin API will return or replace as text.
   Same route as rockkt-video-still-v1.js and rockkt-home-fix-v1.css. When that
   template is next rebuilt, this markup belongs in it and this file can go.

   Both controls are made properly operable, not just clickable: a real role, a
   tab stop, aria state, and Enter/Space — a div with a click handler is a
   control only for people using a mouse. */
(function () {
  var built = false;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ── the tick ─────────────────────────────────────────────────────────── */
  function verify() {
    var row = document.querySelector('.rk-verify');
    if (!row || row.getAttribute('data-rk-fx')) return;
    row.setAttribute('data-rk-fx', '1');

    var box = row.querySelector('.rk-box');
    if (box && !box.querySelector('svg')) {
      box.innerHTML = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.2 8.4 6.5 11.6 12.8 4.9"/></svg>';
    }

    /* The markup is a <label> with no <input> in it, so it has never been a
       real control. Give it the semantics it has always looked like it had. */
    row.setAttribute('role', 'checkbox');
    row.setAttribute('aria-checked', 'false');
    row.setAttribute('tabindex', '0');

    /* The address the mock has already "found", so the email quotes the same
       one the panel above it shows rather than a second invented address. */
    var addr = document.querySelector('.qs-addr .aa');
    var line = addr ? addr.textContent.trim() : 'Top Floor, Clockwise Building, Finzels Reach, Bristol';

    var wrap = el('div', 'rk-vmail');
    var inner = el('div', 'rk-vm-in');

    var head = el('div', 'rk-vm-head');
    head.appendChild(el('span', 'dot'));
    head.appendChild(document.createTextNode('Email drafted'));
    head.appendChild(el('span', 'when', 'just now'));

    var to = el('div', 'rk-vm-to');
    to.appendChild(document.createTextNode('To '));
    to.appendChild(el('b', null, 'Mark Sutton'));
    to.appendChild(document.createTextNode(' · Northwind Energy'));

    var btns = el('div', 'rk-vm-btns');
    btns.appendChild(el('span', 'ok', "Yes, that's right"));
    btns.appendChild(el('span', null, 'Use a different address'));
    btns.appendChild(el('span', null, 'No thanks'));

    inner.appendChild(head);
    inner.appendChild(to);
    inner.appendChild(el('div', 'rk-vm-sub', 'A quick check before this is posted'));
    inner.appendChild(el('div', 'rk-vm-body',
      /* The sender is Sophie Hart at Halbrook — the Rockkt CUSTOMER, not Rockkt. This
         line first read "Mark Reynolds at Rockkt", which collided with Mark Sutton (the
         recipient, named twelve lines up) and made Rockkt the sender, which the rest of
         the page never does. A visitor is meant to see themselves sending this, not us. */
      'Hi Mark — Sophie Hart at Halbrook is sending you something. Is ' + line + ' still the best place for it?'));
    inner.appendChild(btns);
    inner.appendChild(el('div', 'rk-vm-foot',
      'Rockkt holds the send for 12 business hours while they answer. Nothing is posted until they do, or the window closes.'));
    wrap.appendChild(inner);
    row.parentNode.insertBefore(wrap, row.nextSibling);

    function toggle() {
      var on = row.classList.toggle('on');
      row.setAttribute('aria-checked', on ? 'true' : 'false');
      /* The sidebar body is a 520px scroller, so a panel opening near the
         bottom of it can open out of sight. */
      if (on) setTimeout(function () { reveal(wrap); }, 260);
    }
    row.addEventListener('click', function (e) { e.preventDefault(); toggle(); });
    row.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
    });
  }

  /* ── the portal button ────────────────────────────────────────────────── */
  function portal() {
    var btn = document.querySelector('.rk-portal');
    if (!btn || btn.getAttribute('data-rk-fx')) return;
    btn.setAttribute('data-rk-fx', '1');

    /* The arrow is part of the label text. Lift it into its own element so it
       can turn to point at what it opens. */
    var lab = btn.querySelector('b');
    if (lab && lab.textContent.indexOf('→') > -1) {
      lab.textContent = lab.textContent.replace(/\s*→\s*$/, '') + ' ';
      lab.appendChild(el('span', 'rk-parrow', '→'));
    }

    btn.setAttribute('role', 'button');
    btn.setAttribute('tabindex', '0');
    btn.setAttribute('aria-expanded', 'false');

    var wrap = el('div', 'rk-pmore');
    var inner = el('div', 'rk-pmore-in');
    [['🎬', 'Video message'], ['🎁', 'Gift Lab'], ['🚀', 'Landing Pad']]
      .forEach(function (c) {
        var chip = el('span', 'rk-pchip');
        chip.appendChild(el('span', 'e', c[0]));
        chip.appendChild(document.createTextNode(c[1]));
        inner.appendChild(chip);
      });
    wrap.appendChild(inner);
    wrap.appendChild(el('div', 'rk-pnote', 'All three live in the portal, on the same send.'));
    btn.parentNode.insertBefore(wrap, btn.nextSibling);

    function toggle() {
      var on = btn.classList.toggle('open');
      btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) setTimeout(function () { reveal(wrap); }, 240);
    }
    btn.addEventListener('click', toggle);
    btn.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter' || e.key === 'Spacebar') { e.preventDefault(); toggle(); }
    });
  }

  /* Scroll a newly opened panel into the sidebar's own scroller, and only that
     scroller — scrollIntoView would drag the whole page around instead. */
  function reveal(node) {
    var pane = node.closest ? node.closest('.qs-body') : null;
    if (!pane) return;
    var over = (node.offsetTop + node.offsetHeight) - (pane.scrollTop + pane.clientHeight);
    if (over > 0) {
      try { pane.scrollTo({ top: pane.scrollTop + over + 12, behavior: 'smooth' }); }
      catch (e) { pane.scrollTop = pane.scrollTop + over + 12; }
    }
  }

  function boot() {
    if (built) return;
    verify();
    portal();
    built = !!document.querySelector('.rk-verify[data-rk-fx]');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
})();
